import '../style/scroll-box-CvX7_pPv.css'
import { defineComponent as u, openBlock as o, createElementBlock as _, createVNode as t, Transition as n, withCtx as s, unref as e, createBlock as c, createCommentVNode as i, createElementVNode as p, renderSlot as k } from "vue";
import a from "./internalComponents/ScrollArrow.js";
import { useScrollContainer as w } from "./hooks/useScrollContainer.js";
const C = { class: "e-scroll-box" }, x = /* @__PURE__ */ u({
  name: "e-scroll-box",
  __name: "scroll-box",
  props: {
    scrollArrowOverrides: {}
  },
  setup(h) {
    const { containerRef: d, showLeftArrow: f, showRightArrow: m, handleArrowClick: l } = w({
      showScrollArrows: !0,
      scrollIntoViewOnClick: !0
    });
    return (r, v) => (o(), _("div", C, [
      t(n, { name: "fade" }, {
        default: s(() => [
          e(f) ? (o(), c(a, {
            key: 0,
            type: "left",
            overrides: r.scrollArrowOverrides,
            onClick: e(l)
          }, null, 8, ["overrides", "onClick"])) : i("", !0)
        ]),
        _: 1
      }),
      p("div", {
        ref_key: "containerRef",
        ref: d,
        class: "e-scroll-box__inner"
      }, [
        k(r.$slots, "default")
      ], 512),
      t(n, { name: "fade" }, {
        default: s(() => [
          e(m) ? (o(), c(a, {
            key: 0,
            type: "right",
            overrides: r.scrollArrowOverrides,
            onClick: e(l)
          }, null, 8, ["overrides", "onClick"])) : i("", !0)
        ]),
        _: 1
      })
    ]));
  }
});
export {
  x as default
};
//# sourceMappingURL=scroll-box.js.map
